<template>
  <!-- The device gate short-circuits the whole app: until this device is
       registered and approved, neither the login page nor the shell renders. -->
  <DeviceGate v-if="!deviceAllowed" />
  <component :is="layout" v-else>
    <router-view v-if="!useShell" />
  </component>
</template>

<script>
import { mapGetters } from 'vuex'
import AppShell from '@/layouts/AppShell.vue'
import DeviceGate from '@/components/DeviceGate.vue'

export default {
  name: 'App',

  components: { DeviceGate },

  computed: {
    ...mapGetters('device', { deviceAllowed: 'isAllowed' }),

    // Login page renders without the shell; everything else gets the AppShell chrome.
    useShell() {
      return this.$route?.meta?.requiresAuth === true
    },
    layout() {
      return this.useShell ? AppShell : 'router-view'
    },
  },

  created() {
    // Runs once on app start, before login — a blocked device is turned away
    // at the door rather than after authenticating.
    this.$store.dispatch('device/register')
  },
}
</script>
